import React, { useContext } from "react";
import { Alert, Skeleton } from "@mui/material";
import { FormDataContext } from "../contexts/FormContext";
import { useSelector } from "react-redux";
import { useGetMissionExpertDataQuery } from "modules/pvs_activities/redux/service/missionExpert";
import _ from "lodash";
import RadioSelectionField from "../core/RadioSelectionField";
import Heading from "../core/Heading";

const defaultProps = {
    id: "",
    element: {},
    isReadOnly: false,
    value: "",
    onChange: () => {},
};

const PeerReviewerAction = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };

    const formDataContext = useContext(FormDataContext);
    const authData = useSelector((s) => s.auth.data);

    const missionExpertRes = useGetMissionExpertDataQuery(
        {
            missionId: formDataContext?.missionId,
            movementId: formDataContext?.movementId,
            userId: authData.id,
        },
        { skip: formDataContext.mode === "preview" }
    );

    return (
        <>
            <div className="my-3 bg-light-3 p-4">
                <Heading label="Peer Reviewer Invitation:" className="mb-1" />
                {missionExpertRes.status === "uninitialized" ||
                (missionExpertRes.isSuccess && missionExpertRes.data === null) ? (
                    <Alert severity="info">Aaah! It seems there is no peer reviewer invitation for you.</Alert>
                ) : missionExpertRes.isLoading ? (
                    <Skeleton variant="rounded" width={"100%"} height={120} />
                ) : missionExpertRes.isError ? (
                    <Alert severity="error">Oh! It seems there is error loading data.</Alert>
                ) : missionExpertRes.isSuccess ? (
                    <>
                        <strong className="mb-2">
                            You have been proposed for the above mission as a Peer Reviewer. Please either accept or
                            reject the proposal:
                        </strong>
                        <div>
                            {props.isReadOnly === true ? (
                                missionExpertRes.data.response_status === 1 ? (
                                    'Your selected option is "Accept"'
                                ) : missionExpertRes.data.response_status === 2 ? (
                                    'Your selected option is "Reject"'
                                ) : (
                                    "No Option Selected"
                                )
                            ) : (
                                <RadioSelectionField
                                    value={props.value}
                                    onChange={props.onChange}
                                    plain={true}
                                    hasOptions={true}
                                    options={[
                                        { label: "Accept", value: "accept", id: "accept" },
                                        { label: "Reject", value: "reject", id: "reject" },
                                    ]}
                                    useOptionLabel={true}
                                />
                            )}
                        </div>
                    </>
                ) : (
                    "-"
                )}
            </div>
        </>
    );
};

export default PeerReviewerAction;
